import FlagIconsContainer from "../../../Components/Icon/FlagIcon/FlagIconsContainer";

const FlagIcon = () => {
  return <FlagIconsContainer />;
};

export default FlagIcon;
